"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formConfig = {
  name: "requestReassign",
  fields: {
    comments: {
      id: "comments-reopen",
      jsonPath: "actionInfo[0].comments"
    },
    textarea: {
      id: "textarea",
      hintText: "CS_COMMON_COMMENTS_PLACEHOLDER"
    },
    action: {
      id: "action",
      jsonPath: "actionInfo[0].action",
      value: "requestforreassign"
    }
  },
  submit: {
    type: "submit",
    label: "ES_REQUEST_REQUEST_RE_ASSIGN",
    id: "reopencomplaint-submit-action"
  },
  action: "_update",
  redirectionRoute: "/reassign-success",
  saveUrl: "/rainmaker-pgr/v1/requests/_update"
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/pgr/pgr-employee/requestReassign.js
// module id = ../lib/egov-ui-kit/config/forms/specs/pgr/pgr-employee/requestReassign.js
// module chunks = 504